module.exports = __webpack_public_path__ + "img/blazer_2.13ecaabd.png";